import { render, staticRenderFns } from "./SelectStudy.vue?vue&type=template&id=6768e2d9&"
import script from "./SelectStudy.vue?vue&type=script&lang=js&"
export * from "./SelectStudy.vue?vue&type=script&lang=js&"
import style0 from "./SelectStudy.vue?vue&type=style&index=0&id=6768e2d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports